<template>
  <el-skeleton-item variant="text" class="skeleton-value" />
  <el-skeleton-item variant="text" class="skeleton-label" />
</template>

<script setup>
defineOptions({ name: 'SkeletonCell' });
</script>
